import { render, staticRenderFns } from "./RowFlex.vue?vue&type=template&id=09bc128b&functional=true&"
import script from "./RowFlex.vue?vue&type=script&lang=js&"
export * from "./RowFlex.vue?vue&type=script&lang=js&"
import style0 from "./RowFlex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports